import { Container } from '@volkswagen-onehub/components-core';
import { useRouteError } from 'react-router-dom';
import { TribalContextType, useTribalContext } from '../context/tribal';
import { Error } from '../modules/pages';

interface CodeComponentProps {
  children: React.ReactNode;
}
const CodeComponent = ({ children }: CodeComponentProps) => {
  return (
    <pre
      style={{
        maxWidth: '600px',
        whiteSpace: 'pre-wrap',
        backgroundColor: '#181818',
        borderRadius: '8px',
        padding: '1rem',
        color: 'white',
      }}
    >
      {children}
    </pre>
  );
};

const RouteBoundary = () => {
  const error: any = useRouteError();

  window.tb.logger.debug(error);

  const errorAsJson: any = JSON.stringify(error, null, 2);
  const { configManager } = useTribalContext() as TribalContextType;

  const debug = configManager.get('debug');

  if (debug === true) {
    return (
      <div>
        <h1>Route Boundary</h1>
        <p>Debug Mode: {debug}</p>
        <p>Oops, there's been an error</p>

        <h3>Message: </h3>
        <CodeComponent>{error?.message ?? 'null'}</CodeComponent>

        <h3>Object: </h3>
        <CodeComponent>
          {errorAsJson.length > 1
            ? errorAsJson
            : JSON.stringify(error, Object.getOwnPropertyNames(error))}
        </CodeComponent>
      </div>
    );
  }

  return (
    <Container wrap="always">
      <Error error={error} />
    </Container>
  );
};

export default RouteBoundary;
